module.exports = __webpack_public_path__ + "img/y-182.4a264f6b.png";